export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "%0 z %1": "",
        "%0 znaków": "",
        "<Brak nazwy>": "",
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "",
        "${el.text}": "",
        "${getCurrentScope().label}": "",
        "${item.entityName}": "",
        "${item.text}": "",
        "${props.inputPlaceholder}": "",
        "${str}": "",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "",
        "1 godzina": "",
        "10 minut": "",
        "12 godzin": "",
        "15 minut": "",
        "24 godziny": "",
        "3 godziny": "",
        "30 minut": "",
        "5 minut": "",
        "6 godzin": "",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "",
        "Adaptive sampling": "",
        "Administracja": "",
        "Administracja - Kraje": "",
        "Administracja - Miasta": "",
        "Administracja - Role": "",
        "Administracja - Stanowiska pracy": "",
        "Administracja - Użytkownicy": "",
        "Administracja - Województwa": "",
        "Administracja - Zespoły": "",
        "Administratorzy": "",
        "Adres domenowy": "",
        "Adres e-mail potwierdzony": "",
        "Adres email": "",
        "Adres email nadawcy": "",
        "Adres IP": "",
        "Adres IP: %0": "",
        "Akceptuj": "",
        "Akcja": "",
        "Akcje": "",
        "Aktualizacja: {0}": "",
        "Aktualizuj": "",
        "Aktualna sesja": "",
        "Aktualne hasło": "",
        "Aktualne urządzenie": "",
        "Aktywna": "",
        "Aktywne": "",
        "Aktywne kanały komunikacji": "",
        "Aktywne sesje": "",
        "Aktywne źródła": "",
        "Aktywni": "",
        "Aktywny": "",
        "Alias": "",
        "Alias został przepięty.": "",
        "Angielski": "",
        "Anonimizuj": "",
        "Anuluj": "",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "",
        "Application Insights": "",
        "Aranżacja": "",
        "Autor": "",
        "Azure AD": "",
        "Azure Application Insights": "",
        "Basic Auth": "",
        "Bezpieczeństwo": "",
        "Bezpieczne połączenie SSL": "",
        "Blokada konta": "",
        "Blokada konta do": "",
        "Blokowanie kont": "",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "",
        "Błąd w kodzie MJML.": "",
        "Błędne": "",
        "Błędy": "",
        "Bool": "",
        "Brak danych": "",
        "Brak elementów": "",
        "Brak kluczy": "",
        "Brak nowych powiadomień.": "",
        "Brak opcji": "",
        "Brak wersji": "",
        "Brak wyboru": "",
        "Brak wyników": "",
        "Brak zdefiniowanych ról.": "",
        "Brak zdefiniowanych zespołów.": "",
        "Bramka SMS": "",
        "Centrum powiadomień": "",
        "Client ID": "",
        "Client Secret": "",
        "Co 10 dni": "",
        "Co 10 minut": "",
        "Co 12 godzin": "",
        "Co 15 minut": "",
        "Co 2 godziny": "",
        "Co 2 minuty": "",
        "Co 2 tygodnie": "",
        "Co 20 minut": "",
        "Co 3 godziny": "",
        "co 3 miesiące": "",
        "Co 3 miesiące": "",
        "co 30 dni": "",
        "Co 30 minut": "",
        "Co 4 miesiące": "",
        "Co 5 dni": "",
        "Co 5 minut": "",
        "Co 6 godzin": "",
        "co 6 miesięcy": "",
        "Co drugi dzień": "",
        "Co drugi miesiąc": "",
        "Co godzinę": "",
        "Co miesiąc": "",
        "Co minutę": "",
        "Co pół roku": "",
        "co rok": "",
        "Co tydzień": "",
        "Codziennie": "",
        "Connection String": "",
        "Cron": "",
        "Czas": "",
        "Czas nieaktywności użytkownika po którym zostanie wylogowany z panelu administracyjnego [min": "",
        "Czas trwania blokady": "",
        "Czas uruchomienia": "",
        "Czerwiec": "",
        "Członkowie zespołu": "",
        "Czy aby na pewno chesz zrestartować aplikacje?": "",
        "Czy na pewno chcesz usunąć widget?": "",
        "Dalej": "",
        "Dashboard aktywny": "",
        "Dashboard domyślny": "",
        "Dashboard został dodany.": "",
        "Dashboard został skopiowany.": "",
        "Dashboard został usunięty.": "",
        "Dashboard został zaktualizowane.": "",
        "Dashboardy": "",
        "Data do": "",
        "Data dodania": "",
        "Data modyfikacji": "",
        "Data od": "",
        "Data opuszczenia zespołu": "",
        "Data otrzymania": "",
        "Data rejestracji": "",
        "Data rozpoczęcia": "",
        "Data uruchomienia": "",
        "Data uruchomienia (UTC)": "",
        "Data usunięcia": "",
        "Data utworzenia": "",
        "Data utworzenia wersji": "",
        "Data użycia": "",
        "Data wygaśnięcia": "",
        "Data wylogowania": "",
        "Data wysłania": "",
        "Data zakończenia": "",
        "Data zalogowania": "",
        "Data zdarzenia": "",
        "DateTime": "",
        "Długość historii haseł": "",
        "Dni": "",
        "Do akceptacji": "",
        "do czasu ręcznego odblokowania": "",
        "Docs": "",
        "Dodaj": "",
        "Dodaj dashboard": "",
        "Dodaj do zespołu": "",
        "Dodaj dział": "",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "",
        "Dodaj nowy folder": "",
        "Dodaj pliki": "",
        "Dodaj rolę": "",
        "Dodaj shortcode": "",
        "Dodaj słowo": "",
        "Dodaj synonimy": "",
        "Dodaj szablon": "",
        "Dodaj token": "",
        "Dodaj typ": "",
        "Dodaj użytkownika": "",
        "Dodaj wiadomość": "",
        "Dodaj widget": "",
        "Dodaj zastępstwo": "",
        "Dodaj zespół": "",
        "Dodaj zmienne dla szablonu": "",
        "Dodaj źródło": "",
        "dodał": "",
        "dodane i edytowane przeze mnie": "",
        "Dodane przez": "",
        "Dodanie": "",
        "Dodanie dashboardu": "",
        "Dodanie działu": "",
        "Dodanie roli": "",
        "Dodanie użytkownika": "",
        "Dodanie zastępstwa": "",
        "Dodanie zespołu": "",
        "Dodanie źródła": "",
        "dodany": "",
        "Dodanych plików %0 (limit wynosi %1).": "",
        "Dokument PDF": "",
        "Dokument tekstowy": "",
        "Dołącz stack trace": "",
        "Domena": "",
        "Domyślna": "",
        "Domyślne": "",
        "Domyślne filtry": "",
        "Domyślny": "",
        "Domyślny poziom logowania": "",
        "Dostęp niezdefiniowany": "",
        "Dostęp przyznany": "",
        "Dostęp zabroniony": "",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "",
        "Double": "",
        "Dozwolone rozszerzenia: %0.": "",
        "Dozwolone typy plików: %0.": "",
        "Dsn": "",
        "Duży układ siatki": "",
        "Dział aktywny": "",
        "Dział nadrzędny": "",
        "Dział został dodany.": "",
        "Dział został zaktualizowany.": "",
        "Działania masowe": "",
        "E-mail": "",
        "Edycja aranżacji dashboardu": "",
        "Edycja dashboardu": "",
        "Edycja działu": "",
        "Edycja logów": "",
        "Edycja roli": "",
        "Edycja użytkownika": "",
        "Edycja zastępstwa": "",
        "Edycja zespołu": "",
        "Edycja źródła": "",
        "Edytowana wersja": "",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "",
        "Edytuj": "",
        "Edytuj członka grupy": "",
        "Edytuj filtr": "",
        "Edytuj szablon": "",
        "Edytuj typ": "",
        "Edytuj uprawnienia": "",
        "Edytuj wiadomość": "",
        "Edytuj wpis": "",
        "Eksport": "",
        "ElasticSearch": "",
        "Element został przywrócony.": "",
        "Element został usunięty.": "",
        "Elementy zostały usunięte.": "",
        "Email potwierdzony": "",
        "False": "",
        "Filtr dla synchronizacji działów": "",
        "Filtr dla synchronizacji użytkowników": "",
        "Filtr domyślny": "",
        "Filtr prywatny": "",
        "Filtr został usunięty": "",
        "Filtr został zapisany": "",
        "Filtry": "",
        "Firebase": "",
        "Firebase config": "",
        "Folder główny": "",
        "Folder plików": "",
        "Foldery": "",
        "Godziny": "",
        "Grudzień": "",
        "Grupa": "",
        "Harmonogram zadań": "",
        "Harmonogram został zmieniony": "",
        "Hasło": "",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "",
        "Hasło zostało zmienione. Zaloguj się ponownie": "",
        "Health": "",
        "Historia logowania": "",
        "Historia zadania": "",
        "Host": "",
        "i": "",
        "Id": "",
        "ID": "",
        "ID lub typ zadania": "",
        "Id modelu: %0": "",
        "Id obiektu": "",
        "Id sesji": "",
        "ID zadania": "",
        "Id zdarzenia": "",
        "Identyfikator zadania": "",
        "Imię": "",
        "Imię i Nazwisko": "",
        "Import": "",
        "Import użytkowników": "",
        "Indeks": "",
        "Indeks został usunięty.": "",
        "Inspekcja": "",
        "Instalacja": "",
        "Int": "",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "",
        "Język": "",
        "Kalendarz - Kategorie zasobów": "",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "",
        "kanał wymagany": "",
        "Kanały": "",
        "Kanały komunikacji": "",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "",
        "Kanały włączone w ustawieniach aplikacji": "",
        "Katalog został utworzony": "",
        "Kategoria": "",
        "Key": "",
        "Key pair": "",
        "Klucz prywatny": "",
        "Klucz publiczny": "",
        "Klucze": "",
        "Klucze są nie prawidłowe.": "",
        "Klucze są prawidłowe.": "",
        "Kod MJML": "",
        "Kod wertfikacyjny": "",
        "Kod weryfikacyjny jest nieprawidłowy.": "",
        "Kolejka": "",
        "Kolor drugorzędny: %0": "",
        "Kolor icon na panelu z aplikacjami: %0": "",
        "Kolor podstawowy: %0": "",
        "Kolor tekstu aktywnej pozycji menu: %0": "",
        "Kolor tła": "",
        "Kolor tła panelu z aplikacjami: %0": "",
        "Kolory zostały przywrócone.": "",
        "Kolory zostały zapisane.": "",
        "Komunikat": "",
        "Konfiguracja domyślna": "",
        "Konfiguracja harmonogramu (czas UTC)": "",
        "Konfiguracja stopki oraz logo umieszczanych w wysyłanych powiadomieniach kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "",
        "Konfiguracja została zmieniona.": "",
        "Konsola aplikacji": "",
        "Konsola aplikacji nigdy nie rejestruje logów z poniższych przestrzeni nazw:": "",
        "Konta użytkowników zostały odblokowane": "",
        "Konta użytkowników zostały przypisane do zespołu": "",
        "Konta użytkowników zostały usunięte z systemu": "",
        "Konta użytkowników zostały zablokowane": "",
        "Kontakt": "",
        "Kontakty - Typ działania": "",
        "Konto aktywne": "",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "",
        "Konto z dostępem do panelu": "",
        "Konto zanonimizowane": "",
        "Konwertuj obrazy do formatu WebP": "",
        "Kopiuj": "",
        "Kopiuj pole": "",
        "Kosz": "",
        "Kwiecień": "",
        "LDAPS (LDAP over SSL)": "",
        "Lewy panel": "",
        "Licencja": "",
        "Liczba wyników na stronie": "",
        "Lider": "",
        "linie": "",
        "Lipiec": "",
        "Lista dozwolonych / wykluczonych żądań HTTP": "",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "",
        "Lista indeksów": "",
        "Lista jest pusta": "",
        "Lista zaufanych adresów IP": "",
        "Listopad": "",
        "Logi wydajnościowe": "",
        "Login": "",
        "Logo": "",
        "Logowanie": "",
        "Logowanie zakończyło się niepowodzeniem.": "",
        "Logowanie zależności / żądań typu HTTP": "",
        "Logowanie zdarzeń": "",
        "Loguj wybrane": "",
        "Long": "",
        "Luty": "",
        "Ładowanie elementów...": "",
        "Maj": "",
        "Maksymalny rozmiar pliku: %0MB.": "",
        "Mały układ siatki": "",
        "Mappingi": "",
        "Marzec": "",
        "Metoda autentykacji": "",
        "Miesiąc": "",
        "Miesiące": "",
        "Minimalna długość hasła": "",
        "Minuty": "",
        "Modyfikacja": "",
        "Moje dokumenty": "",
        "Moje filtry": "",
        "Moje konto": "",
        "Moje pliki": "",
        "Monitor kolejek": "",
        "Monitoring": "",
        "Monitoring aplikacji": "",
        "Monitoruj statystyki .NET": "",
        "Monitoruj żądania HTTP": "",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "",
        "Mój tytuł": "",
        "Na pewno usunąć": "",
        "Nadawca": "",
        "Name": "",
        "Narzędzie integruje się z platformą Firebase (powiadomienia push)": "",
        "Narzędzie integruje się z platformą SMSAPI.pl": "",
        "Następna strona": "",
        "Nazwa": "",
        "Nazwa aliasu": "",
        "Nazwa dashboardu": "",
        "Nazwa działu": "",
        "Nazwa filtra": "",
        "Nazwa katalogu": "",
        "Nazwa nadawcy": "",
        "Nazwa pliku": "",
        "Nazwa pliku została zmieniona.": "",
        "Nazwa pola": "",
        "Nazwa powiadomienia": "",
        "Nazwa roli": "",
        "Nazwa szablonu": "",
        "Nazwa typu": "",
        "Nazwa urządzenia": "",
        "Nazwa użytkownika": "",
        "Nazwa zadania": "",
        "Nazwa zespołu": "",
        "Nazwa zmiennej nie może być pusta.": "",
        "Nazwa źródła": "",
        "Nazwisko": "",
        "Nie": "",
        "Nie loguj wybranych": "",
        "Nie masz uprawnień do panelu administracyjnego.": "",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "",
        "Nie możesz modyfikować uprawnień": "",
        "Nie można usunąć swojego konta.": "",
        "Nie udało się pobrać konfiguracji dashboardu": "",
        "Nie udało się pobrać listy działów": "",
        "Nie udało się pobrać listy filtrów": "",
        "Nie udało się pobrać listy kanałów": "",
        "Nie udało się pobrać listy kolejek": "",
        "Nie udało się pobrać listy powiadomień": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy typów modeli": "",
        "Nie udało się pobrać listy wydziałów": "",
        "Nie udało się pobrać listy zespołów": "",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się pobrać ustawień kont użytkowników": "",
        "Nie udało się pobrać widgetu/ów": "",
        "Nie udało się usunąć szablonu": "",
        "Nie udało się wykonać akcji": "",
        "Nie udało się wysłać pliku": "",
        "Nie udało się załadować elementów": "",
        "Nie udało się zapisać filtra": "",
        "Nie udało się zapisać ustawień dashboardu": "",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "",
        "Nie wybrano żadnego użytkownika.": "",
        "nie wymuszaj zmiany hasła": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nie znaleziono filtrów.": "",
        "Nie znaleziono kolumn.": "",
        "Nie znaleziono pasujących elementów.": "",
        "Nie znaleziono właściwego widgetu": "",
        "Nie znaleziono żadnego pola.": "",
        "Nie znaleziono żadnych elementów": "",
        "Nie znaleziono żadnych użytkowników.": "",
        "Nie znaleziono żadnych wyników.": "",
        "Nieaktywni": "",
        "niedozwolone rozszerzenie pliku (%0)": "",
        "niedozwolony typ pliku (%0)": "",
        "Niepotwierdzeni": "",
        "Nieprawidłowy adres email": "",
        "Nieprawidłowy adres URL": "",
        "Nieprzeczytane": "",
        "Nieudane logowania": "",
        "Nieznany typ pliku": "",
        "Nikomu nie przydzielono uprawnień": "",
        "Nowe hasło": "",
        "np. (&(objectClass=organizationalUnit))": "",
        "np. (&(objectClass=user)": "",
        "Numer sesji": "",
        "Numer telefonu": "",
        "OAuth2 dla Exchange Online": "",
        "Obiekt %0 został %1": "",
        "Obraz został wycięty.": "",
        "Oczekujące": "",
        "Oczekuje na wysłanie": "",
        "Odblokuj": "",
        "Odrzucone": "",
        "Odśwież": "",
        "Odznacz": "",
        "Odznacz wszystkie": "",
        "Ok": "",
        "Opis": "",
        "Opis zespołu": "",
        "Opisy": "",
        "Opróżnij kategorię": "",
        "Optymalizuj rozdzielczość obrazów": "",
        "Oraz hasło": "",
        "Oraz nowe hasło": "",
        "Organizacja": "",
        "Organizacja została usunięta.": "",
        "Osoba zastępowana": "",
        "Osoba zastępująca": "",
        "Ostatnia aktywność": "",
        "Ostatnia strona": "",
        "Ostrzeżenia": "",
        "Otwórz": "",
        "Oznacz": "",
        "Oznacz jako nieprzeczytane": "",
        "Oznacz jako przeczytane": "",
        "Oznacz powiadomienia": "",
        "Oznacz wszystkie jako przeczytane": "",
        "Oznacz wybrane jako nieprzeczytane": "",
        "Oznacz wybrane jako przeczytane": "",
        "Paleta kolorów": "",
        "Październik": "",
        "Pierwsza strona": "",
        "Plik audio": "",
        "Plik binarny": "",
        "Plik CSS": "",
        "Plik CSV": "",
        "Plik DOC": "",
        "Plik DOCX": "",
        "Plik GIF": "",
        "Plik HTML": "",
        "Plik jest wysyłany": "",
        "Plik JPEG": "",
        "Plik JPG": "",
        "Plik MP4": "",
        "Plik PNG": "",
        "Plik skompresowany": "",
        "Plik z logami": "",
        "Plik ZIP": "",
        "Plik został wysłany": "",
        "Pliki": "",
        "Pliki do wysłania: %0": "",
        "Pliki współdzielone": "",
        "po %0 nieudanych próbach logowania": "",
        "Po jednym synonimie w wierszu": "",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "",
        "Pobierz": "",
        "Poczta wychodząca": "",
        "Podaj kod weryfikacyjny": "",
        "Podaj swój adres email": "",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "",
        "Podczas próby logowania wystąpił problem z zapisem recaptcha. Spróbuj ponownie": "",
        "Podczas przesyłania plików wystąpił nieznany błąd": "",
        "Podgląd": "",
        "Podgląd HTML": "",
        "Podgląd szablonu": "",
        "Podziedziałek - Piątek": "",
        "Pokaż historię": "",
        "Pokaż szczegóły": "",
        "Pokaż tylko moje dokumenty": "",
        "Pokaż w koncie użytkownika": "",
        "Pokaż więcej": "",
        "pokaż więcej...": "",
        "Pole \"Email\" jest wymagane.": "",
        "Pole \"Liczba wyników na stronie\" jest wymagane.": "",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "",
        "Pole \"Nazwa\" jest wymagane.": "",
        "Pole \"Szerokość\" jest wymagane.": "",
        "Pole \"Wysokość\" jest wymagane.": "",
        "Pole jest wymagane": "",
        "Pole nie może zawierać spacji": "",
        "Pole skopiowane": "",
        "Polityka prywatności": "",
        "Polski": "",
        "Poprzednia strona": "",
        "Porównaj %0": "",
        "Porównaj z edytowaną wersją": "",
        "Porównywana wersja": "",
        "Port": "",
        "Posiada załączniki": "",
        "Potwierdzenia": "",
        "Potwierdzenie kopiowania": "",
        "Potwierdzenie przywrócenia": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie wylogowania użytkownika": "",
        "Potwierdzenie zmiany statusu": "",
        "Potwierdź": "",
        "Potwierdź akceptację": "",
        "Powiadomienia": "",
        "Powiadomienia Firebase": "",
        "Powiadomienia mailowe": "",
        "Powiadomienia zostały skonfigurowane.": "",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiadomienie zbiorowe zostało dodane.": "",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "",
        "Powiększ kod MJML": "",
        "Powiększ podgląd": "",
        "Powrót": "",
        "Powtórz hasło": "",
        "Powtórzone": "",
        "Pozostałe": "",
        "Pozostało %0 znaków.": "",
        "Prawy panel": "",
        "Predefiniowane tła panelu z aplikacjami": "",
        "Predefiniowane zestawy kolorów": "",
        "Profil użytkownika": "",
        "Profil został zaktualizowany.": "",
        "Prometheus": "",
        "Próbkowanie": "",
        "Prywatny": "",
        "Przebudowanie indeksów": "",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "",
        "Przeczytane": "",
        "Przefiltrowani użytkownicy": "",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "",
        "Przeindeksowanie danych": "",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "",
        "Przeniesienie wybranych elementów": "",
        "przeniesiony do kosza": "",
        "Przenieś": "",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "przeniósł do kosza": "",
        "Przepnij alias": "",
        "Przesyłanie plików powiodło się.": "",
        "Przetestuj poprawność zapisanych kluczy": "",
        "Przetestuj ustawienia poczty": "",
        "Przetestuj ustawienia Sms": "",
        "Przetwarzane": "",
        "Przykład: domena\\użytkownik": "",
        "Przykład: użytkownik@domena": "",
        "Przypisanie do zespołu": "",
        "Przypisanie ról": "",
        "Przywrócenie": "",
        "przywrócił z kosza": "",
        "przywrócony z kosza": "",
        "Przywróć": "",
        "Przywróć domyślne": "",
        "Przywróć filtr": "",
        "Przyznaj dostęp": "",
        "Publiczny": "",
        "Ranga": "",
        "ReCaptcha": "",
        "Rejestr zmian": "",
        "Repozytorium plików": "",
        "Resetuj": "",
        "Rok": "",
        "Rola": "",
        "Rola aktywna": "",
        "Rola domyślna": "",
        "Rola została dodana.": "",
        "Rola została usunięta.": "",
        "Rola została zaktualizowana.": "",
        "Role i uprawnienia": "",
        "Role użytkownika": "",
        "Role zespołu": "",
        "Role zostały przypisane": "",
        "Root": "",
        "Rozmiar": "",
        "Rozmiar pliku": "",
        "Rozmiar zdjęcia został zmieniony.": "",
        "SenderId": "",
        "Sentry": "",
        "Seq": "",
        "Sesja": "",
        "Sesja nr %0": "",
        "Sesja użytkownika": "",
        "Sierpień": "",
        "słowa": "",
        "Słowa wykluczone": "",
        "Słowo": "",
        "Słowo bazowe": "",
        "Słowo wykluczone": "",
        "Słowo zostało dodane.": "",
        "Słowo zostało usunięte.": "",
        "Słowo zostało zaktualizowane.": "",
        "Stan powiadomienia": "",
        "Start": "",
        "Status": "",
        "Status dokumentu został zmieniony.": "",
        "Status edytowanej wersji dokumentu": "",
        "Status powiadomienia": "",
        "Stopka": "",
        "String": "",
        "Strona główna": "",
        "Struktura organizacyjna": "",
        "Styczeń": "",
        "Synonimy": "",
        "Synonimy zostały dodane.": "",
        "Synonimy zostały usunięte.": "",
        "Synonimy zostały zaktualizowane.": "",
        "System": "",
        "System powiadomień": "",
        "Szablon został dodany.": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony email": "",
        "Szczegóły": "",
        "Szczegóły zadania": "",
        "Szczegóły zdarzenia": "",
        "Szczegóły zdarzenia nr %0": "",
        "Szerokość": "",
        "Szkic": "",
        "Sztuczna inteligencja": "",
        "Szukaj we wszystkich wersjach": "",
        "Szukane słowo": "",
        "Ta opcja służy do włączenia lub wyłączenia dziedziczenia w danym polu": "",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "",
        "Tagi": "",
        "Tak": "",
        "Tekst alternatywny": "",
        "Ten dashboard nie zawiera żadnych widgetów": "",
        "Ten element nie zawiera menu kontekstowego.": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "",
        "Tenant ID": "",
        "Teraz": "",
        "Testowy adres email": "",
        "Testowy numer telefonu": "",
        "Testuj": "",
        "Tłumaczenia": "",
        "To pole jest wymagane": "",
        "Token": "",
        "Token został usunięty.": "",
        "Tokeny": "",
        "Tokeny dostępu": "",
        "Tracing": "",
        "Treść": "",
        "True": "",
        "Twoje hasło wygasło. Zmień je na nowe.": "",
        "Twój token": "",
        "Tydzień": "",
        "tylko dokumenty wersjonowane": "",
        "Tylko liderzy": "",
        "Tylko moje": "",
        "Typ": "",
        "Typ konta": "",
        "Typ logowania": "",
        "Typ mime": "",
        "Typ obiektu": "",
        "Typ pliku": "",
        "Typ powiadomienia": "",
        "Typ właściwy": "",
        "typu \"%0\" o ID \"%1\"": "",
        "Typy powiadomień": "",
        "Tytuł": "",
        "Tytuł powiadomienia": "",
        "Układ listy": "",
        "Uprawnienia": "",
        "Uruchom zadanie": "",
        "Urządzenie zostało usunięte.": "",
        "Ustaw domyślny poziom logowania. Logi poniżej tego poziomu nie bądą zbierane niezależnie od pozostałych ustawień.": "",
        "Ustaw poziomy logów które będą wysyłane do poszczególnych rejestrów.": "",
        "Ustaw poziomy logów które będą zbierane z poszczególnych przestrzeni nazw.": "",
        "Ustawienia": "",
        "Ustawienia konta": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Ustawienia widgetów zostały zapisane": "",
        "Ustawienia widgetu": "",
        "Ustawienia zostały zapisane.": "",
        "usunął": "",
        "Usunął": "",
        "Usunięcie": "",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "",
        "usunięty": "",
        "Usuń": "",
        "Usuń dział": "",
        "Usuń filtr": "",
        "Usuń indeks": "",
        "Usuń kolor": "",
        "Usuń plik": "",
        "Usuń plik z listy": "",
        "Usuń urządzenie": "",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "",
        "Usuń z zespołu": "",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "Usuwanie użytkowników": "",
        "Utworzył": "",
        "Utwórz grupy": "",
        "Utwórz katalog": "",
        "Utwórz nowy": "",
        "Uwzględnij wydziały podrzędne": "",
        "Użytkownicy": "",
        "Użytkownicy w tej roli": "",
        "Użytkownik": "",
        "Użytkownik \"%0\" %1 obiekt %2": "",
        "Użytkownik jest liderem zespołu": "",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "",
        "Użytkownik nie należy do żadnego zespołu.": "",
        "Użytkownik posiada pełne uprawnienia": "",
        "Użytkownik został dodany do zespołu.": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został usunięty.": "",
        "Użytkownik został wylogowany.": "",
        "Użytkownik został zaktualizowany.": "",
        "Użytkownik został zanonimizowany.": "",
        "W każdy dzień tygodnia": "",
        "W organizacji nie ma jeszcze żadnych działów.": "",
        "W zespole od %0": "",
        "W zespole od %0 do %1": "",
        "Walidacja certyfikatu SSL": "",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "",
        "Wartość domyślna: (&(objectClass=user)": "",
        "Wartość musi być liczbą całkowitą": "",
        "Wartość musi być liczbą dodatnią": "",
        "Wartość musi być liczbą ujemną": "",
        "Warunki korzystania z usług Google": "",
        "Ważne informacje": "",
        "Wczytywanie danych...": "",
        "Weekend": "",
        "Wersja utowrzona przez": "",
        "Wersje": "",
        "Wersje dokumentu": "",
        "Wiadomość testowa została wysłana.": "",
        "Więcej": "",
        "więcej...": "",
        "Właściwości": "",
        "Włączone": "",
        "Włączony": "",
        "Wpis do kalendarza został usunięty.": "",
        "Wpis został zaktualizowany.": "",
        "Wpisz adresy po przecinku.": "",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "",
        "Wprowadzona wartość jest nieprawidłowa": "",
        "Wprowadzona wartość jest za długa": "",
        "Wprowadzona wartość jest za krótka": "",
        "Wprowadzona wartość jest za niska": "",
        "Wprowadzona wartość jest za wysoka": "",
        "Wprowadzona wartość nie jest poprawna": "",
        "Wróć do logowania": "",
        "Wróć do strony głównej": "",
        "Wrzesień": "",
        "Wstaw cztery kolumny 1/4": "",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "",
        "Wstaw dwie równe kolumny": "",
        "Wstaw szablon informacyjny ze zdjęciem": "",
        "Wstaw trzy kolumny 1/3": "",
        "Wszyscy użytkownicy": "",
        "Wszystkie": "",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!nnCzy na pewno chcesz wykonać akcję??": "",
        "Wszystko": "",
        "wybierz": "",
        "Wybierz": "",
        "wybierz długość": "",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "",
        "Wybierz opcję": "",
        "Wybierz plik": "",
        "Wybierz pliki": "",
        "Wybierz pliki (do {0})": "",
        "Wybierz shortcode": "",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "",
        "Wybierz użytkownika": "",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "",
        "Wybierz zaznaczone": "",
        "wybierz...": "",
        "Wybór języka": "",
        "Wybrane": "",
        "Wybrane elementy zostały przeniesione.": "",
        "Wybrane elementy zostały usunięte.": "",
        "wybrane elementy?": "",
        "Wybrane pliki": "",
        "Wybrane pliki: {0}": "",
        "Wybrane: %0": "",
        "wybranego elementu": "",
        "Wybrano %0 użytkowników.": "",
        "Wybrano jednego użytkownika.": "",
        "Wybrany element został usunięty.": "",
        "wybrany element?": "",
        "wybranych elementów": "",
        "Wydział": "",
        "Wyklucz logowanie zależności": "",
        "Wykonaj": "",
        "Wyloguj się": "",
        "Wyloguj zalogowanego obecnie użytkownika": "",
        "Wyłaczone": "",
        "Wyłączone wysyłanie powiadomień": "",
        "Wyłączony": "",
        "Wymagaj znaków specjalnych w hasłach": "",
        "Wymagane": "",
        "Wymagane jest ustawienie minimalnej długości hasła": "",
        "Wymiary": "",
        "Wymuś zmianę hasła": "",
        "Wysłane": "",
        "Wysokość": "",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "",
        "Wystąpił błąd podczas próby exportu użytkowników.": "",
        "Wystąpił błąd podczas próby importu użytkowników.": "",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpiły błędy podczas zapisywania formularza": "",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "",
        "Wysyłaj dane o użytkowniku": "",
        "Wysyłaj tym kanałem": "",
        "Wysyłka wiadomości": "",
        "Wyszukaj (Ctrl+Q)": "",
        "wyszukaj użytkownika...": "",
        "Wyszukaj widget": "",
        "Wyszukaj...": "",
        "Wyszukiwanie": "",
        "Wyślij": "",
        "Wyślij do": "",
        "Wyślij kod": "",
        "Wyświetlam": "",
        "Wytnij": "",
        "Zaakceptowany": "",
        "Zabierz dostęp": "",
        "Zablokowany": "",
        "Zablokuj": "",
        "Zachowaj oryginalny format obrazów": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "",
        "Zadanie zostało uruchomione.": "",
        "Zadanie zostało włączone": "",
        "Zadanie zostało wyłączone": "",
        "Zaimportowano listę użytkowników.": "",
        "Zakolejkowane": "",
        "Zakończ sesję": "",
        "Zakończ sesję aby wylogować użytkownika": "",
        "Zakończone": "",
        "Zaloguj się": "",
        "Zaloguj się na swoje konto": "",
        "Zamknij": "",
        "Zapamiętaj logowanie": "",
        "Zapamiętane urządzenia": "",
        "Zapisz": "",
        "Zapisz aranżację": "",
        "Zapisz filtr": "",
        "Zapisz i wróć": "",
        "Zapisz ustawienia": "",
        "Zapisz widget": "",
        "Zapisz zmiany": "",
        "Zaplanowane": "",
        "Zapomniałeś hasła?": "",
        "Zastępstwa": "",
        "Zastępstwo": "",
        "Zastępstwo wygasło.": "",
        "Zastępstwo wygaśnie za 10 minut.": "",
        "Zastępstwo wygaśnie za 5 minut.": "",
        "Zastępstwo wygaśnie za minutę.": "",
        "Zastępstwo zostało dodane.": "",
        "Zastępstwo zostało usunięte.": "",
        "Zastępstwo zostało zaktualizowane.": "",
        "Zastępuje osobę": "",
        "Zaufane adresy IP": "",
        "Zawiera": "",
        "Zaznacz": "",
        "Zaznacz wszystkie": "",
        "Zbieranie i przechowywanie logów": "",
        "Zdarzenie": "",
        "Zdjęcie użytkownika": "",
        "Zespoły": "",
        "Zespół": "",
        "Zespół aktywny": "",
        "Zespół został dodany.": "",
        "Zespół został usunięty.": "",
        "Zespół został zaktualizowany.": "",
        "Zmiana hasła": "",
        "Zmiana rozmiaru obrazu": "",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!nnCzy na pewno chcesz zapisać zmiany??": "",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "",
        "Zmiany zostały zapisane.": "",
        "Zmienne": "",
        "Zmień hasło": "",
        "Zmień nazwę": "",
        "Zmień nazwę katalogu": "",
        "Zmień nazwę pliku": "",
        "Zmień rozmiar": "",
        "Zmień status edytowanej wersji": "",
        "Zmień widok": "",
        "zmodyfikował": "",
        "Zmodyfikował": "",
        "zmodyfikowany": "",
        "znaki": "",
        "Zobacz przed opublikowaniem": "",
        "Zobacz sesję użytkownika": "",
        "Zobacz szczegóły sesji użytkownika": "",
        "Zobacz szczegóły zdarzenia": "",
        "Zobacz wszystkie": "",
        "Zobacz wszystkie zastępstwa": "",
        "Został przywrócony oryginalny harmonogram": "",
        "Zresetuj hasło": "",
        "Zrestartuj aplikacje": "",
        "Zwrócony": "",
        "Źródła LDAP": "",
        "Źródła logów": "",
        "Źródło": "",
        "Źródło aktywne": "",
        "Źródło LDAP zostało dodane.": "",
        "Źródło LDAP zostało zaktualizowane.": "",
        "Źródło zostało usunięte.": "",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": ""
    }
};
